import './MessageBlock.css';
import AmsTypography from '../../atoms/AmsTypography/AmsTypography';
import { ProfilePic, AgentWoman } from '../../assets';

const MessageBlock = (props: any) => {
    let {message} = props
    return (
        <>
            <div className="staticMessageBlock">
                <div className='staticMessageImg'>
                    <img src={AgentWoman} alt="Profile Pic" />
                </div>
                <div className="staticMessage">
                <AmsTypography className='messageContent' variant='body1' text={message} />
                    {/* <p>{message}</p> */}
                </div>
            </div>
        </>
    )
}

export default MessageBlock